import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { useEffect, useState } from 'react'
import { NetsuiteVendorSearchAutocomplete } from 'src/helper'
import './SelectNetsuiteVendorDialog.css'

export interface SelectNetsuiteVendorDialogProps {
  open: boolean
  loading: boolean
  defaultVendor: string
  onCancel: () => void
  onProceed: (vendor: string) => void
}

export function SelectNetsuiteVendorDialog({
  open,
  loading,
  defaultVendor,
  onCancel,
  onProceed,
}: SelectNetsuiteVendorDialogProps) {
  const [selectedVendor, setSelectedVendor] = useState('')

  useEffect(() => {
    if (!open) return
    setSelectedVendor(defaultVendor)
  }, [open, defaultVendor])

  const handleCancel = () => {
    setSelectedVendor('')
    onCancel()
  }

  const handleProceed = () => {
    if (!selectedVendor) return
    onProceed(selectedVendor)
    setSelectedVendor('')
  }

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="xs" fullWidth>
      <DialogTitle fontWeight={600}>Select Default Netsuite Vendor</DialogTitle>

      <DialogContent className="select-netsuite-vendor-dialog-content">
        <DialogContentText>Please select a default Vendor in NetSuite for this Supplier.</DialogContentText>

        <NetsuiteVendorSearchAutocomplete
          value={selectedVendor}
          onChange={value => setSelectedVendor(value ?? '')}
          label="Default Netsuite Vendor"
          fullWidth
        />
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={handleCancel}>
          CANCEL
        </Button>
        <Button variant="contained" onClick={handleProceed} disabled={!selectedVendor} loading={loading}>
          PROCEED
        </Button>
      </DialogActions>
    </Dialog>
  )
}
